import { Dialog, DialogContent } from "@mui/material";
import React from "react";
import { reactIcons } from "../../utils/icons";

const InfoModal = ({ open, setOpen, message, type }) => {
  return (
    <>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        scroll={"paper"}
        fullWidth={true}
        maxWidth={"sm"}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{
          "& .MuiPaper-root": {
            background:
              "linear-gradient(292deg, #730000 0%, #000000 75%, #000000 100%)",
            color: "#ffffff",
            border: "1px solid #730000",
          },
        }}
      >
        <DialogContent dividers={true}>
          <div className="text-14 lg:p-2 relative">
            {message}

            {type && (
              <div className="mt-3 flex justify-end">
                {" "}
                <button
                  type="button"
                  onClick={() => {
                    setOpen(false);
                    window?.open(
                      "https://support.mstvalidator.com/portal/en/home",
                      "_blank",
                    );
                  }}
                  className="text-white py-2 flex items-center justify-center px-2 bg-gradient-red w-[75px] rounded-md gap-1 font-normal border border-[#EE0000]  md:w-[135px]"
                >
                  <span className="text-[15px]">OK</span>
                </button>
              </div>
            )}
            <div
              onClick={() => setOpen(false)}
              className="cursor-pointer absolute top-[-10px] right-[-10px] text-white  text-[20px] md:text-[25px] lg:text-[30px] pl-2"
            >
              {reactIcons.close}
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default InfoModal;
